var _path, _path2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoritePlaceOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 1.59031C2.375 1.16505 2.71974 0.820312 3.145 0.820312H12.855C13.2803 0.820312 13.625 1.16505 13.625 1.59031V15.8089C13.625 15.809 13.6249 15.809 13.6249 15.809L8.06427 12.8539C8.02408 12.8325 7.97592 12.8325 7.93573 12.8539L2.37515 15.809C2.37508 15.809 2.375 15.809 2.375 15.8089V1.59031Z",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99902 5.23486C4.99902 3.58182 6.34534 2.23682 8 2.23682C9.65466 2.23682 11.001 3.58182 11.001 5.23486C11.001 7.82311 8.25883 11.0306 8.14198 11.1659C8.10635 11.2072 8.05814 11.227 8 11.231C7.94598 11.231 7.89459 11.2077 7.85895 11.1671C7.7421 11.034 4.99902 7.87951 4.99902 5.23486Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.99695,
    cy: 5.35323,
    rx: 1.16797,
    ry: 1.16622,
    stroke: "currentColor",
    strokeWidth: 0.744244
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritePlaceOutline);
export default __webpack_public_path__ + "static/media/favorite-place-outline.5033d53959d970ac2361fc71624e586d.svg";
export { ForwardRef as ReactComponent };